export default __webpack_public_path__ + "static/media/telugu_edu_f.188c7eca.wav";